import {
  fetchProposalByUuid,
  fetchProjectById,
  fetchProjects,
  fetchPrestationById,
  fetchPrestationProposals,
  fetchPrestations
} from "src/api/projects";
import {
  addProjects,
  addProjectPrestations,
  addPrestationProposals,
  startLoadingProjects,
  startLoadingProposals
} from "../projects";

/**
 * Fetch project once, return it from store if already in
 */
export function fetchProjectOnce(projectId: number) {
  return async (dispatch, getState) => {
    const state = getState();
    if (!state) {
      return null;
    }

    const projectFromStore = state.projects.projects.find(
      p => p.id === projectId
    );
    if (projectFromStore) {
      return projectFromStore;
    }

    const project = await fetchProjectById(projectId);
    dispatch(addProjects([project]));

    return project;
  };
}
/**
 * Fetch prestation once, return it from store if already in
 */
export function fetchPrestationListOnce(projectId: number) {
  return async dispatch => {
    const project = await dispatch(fetchProjectOnce(projectId));

    if (!project) {
      return null;
    }

    const prestations = await fetchPrestations(projectId);
    dispatch(addProjectPrestations(projectId, prestations));

    return prestations;
  };
}
/**
 * Fetch prestation once, return it from store if already in
 */
export function fetchPrestationOnce(projectId: number, prestationId: number) {
  return async dispatch => {
    const project = await dispatch(fetchProjectOnce(projectId));
    if (!project) {
      return null;
    }

    const prestationFromStore = project.prestations.find(
      p => p.id === prestationId
    );
    if (prestationFromStore) {
      return prestationFromStore;
    }

    const prestation = await fetchPrestationById(projectId, prestationId);
    dispatch(addProjectPrestations(projectId, [prestation]));

    return prestation;
  };
}

/**
 * Fetch proposal once, return it from store if already in
 */
export function fetchProposalOnce(
  projectId: number,
  prestationId: number,
  proposalId: string
) {
  return async dispatch => {
    const prestation = await dispatch(
      fetchPrestationOnce(projectId, prestationId)
    );
    if (!prestation) {
      return null;
    }

    /*const proposalFromStore = prestation.proposals.find(
      p => p.id === proposalId
    );
    if (proposalFromStore) {
      return proposalFromStore;
    }*/

    const proposal = await fetchProposalByUuid(proposalId);
    dispatch(addPrestationProposals(projectId, prestationId, [proposal]));

    return proposal;
  };
}

/**
 * Fetch all projects once, return them from store if already in
 */
export function fetchProjectsListOnce() {
  return async (dispatch, getState) => {
    const state = getState();
    if (!state) {
      return null;
    }

    // There is a corner-case where use might have loaded one resource before seeing the whole list
    // So we fetch from api if we have one or less resource
    if (state.projects.projects.length > 1) {
      return state.projects.projects;
    }

    dispatch(startLoadingProjects());

    const projects = await fetchProjects();
    dispatch(addProjects(projects));

    return projects;
  };
}

/**
 * Fetch proposal list once, return them from store if already in
 */
export function fetchProposalsListOnce(
  projectId: number,
  prestationId: number
) {
  return async dispatch => {
    const prestation = await dispatch(
      fetchPrestationOnce(projectId, prestationId)
    );
    if (!prestation) {
      return null;
    }

    // There is a corner-case where use might have loaded one resource before seeing the whole list
    // So we fetch from api if we have one or less resource
    if (prestation.proposals.length > 1) {
      return prestation.proposals;
    }

    dispatch(startLoadingProposals(projectId, prestationId));

    const proposals = await fetchPrestationProposals(projectId, prestationId);
    dispatch(addPrestationProposals(projectId, prestationId, proposals));

    return proposals;
  };
}



// WEBPACK FOOTER //
// ./src/redux/stories/fetchData.ts